var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNoSlogan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 327.61,
    height: 39.707,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3412.6 413.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M317.35 307.04c15.34-28.46 24.05-61.06 24.05-95.76 0-108.31-84.91-196.14-191.11-202l167.06 297.75z",
    style: {
      fill: "#45fcb9",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.26 397.49c32.57-13.87 60.79-36.04 81.98-63.87L118.08 8.97H.27l217.99 388.52z",
    style: {
      fill: "#45ba8e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 413.61h138.99c18.11 0 35.69-2.39 52.43-6.87L85.48 217.93 0 413.62z",
    style: {
      fill: "#339668",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.67 90.81V5.08H411.69v387.33h239.98v-85.73H510.34v-65.59h119.39v-85.21H510.34V90.81h141.33zm184.37 306.68c74.03 0 137.81-43.21 137.81-117.41 0-147.1-175.16-110.35-175.16-168.96 0-16.79 12.91-24.53 28.31-24.53 19.28 0 40.54 11.61 61.11 33.57l64.47-62.67c-30.3-35.54-76.09-57.5-124.3-57.5-61.28 0-129.11 35.55-129.11 118.18 0 134.1 176.03 101.91 176.03 160.61 0 15.41-12.83 26.43-37.96 26.43-33.4 0-60.52-18.08-74.11-47.09l-80.74 50.27c25.82 49.06 82.72 89.09 153.64 89.09zm432.95-5.08h131.1l-187.21-217.6L1376.16 5.08h-125.84l-116.89 129.71h-10.93V5.08h-98.65v387.33h98.65V219.32h6.46L1269 392.41z",
    style: {
      fill: "#45fcb9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1821.52 195.13c27.03-14.81 43.8-40.63 43.8-81.26 0-70.24-52.85-108.88-119.21-108.88h-171.54v387.33h186.35c65.76 0 117.32-36.07 117.32-107.08 0-46.73-22.56-75.23-56.72-90.11zm-54.83-70.32c0 17.39-14.81 34.17-32.87 34.17h-60.6V90.72h60.6c18.07 0 32.87 16.1 32.87 34.09zm-20.57 181.79h-72.9v-68.78h72.9c19.28 0 33.49 16.87 33.49 34.44 0 18.16-14.21 34.34-33.49 34.34zm346.63 90.89c92.94 0 165.76-56.03 165.76-128.33V5h-98.63v245.39c0 34.26-29.69 61.37-67.14 61.37-37.44 0-67.14-27.12-67.14-61.37V5h-98.64v264.16c0 72.3 72.82 128.33 165.78 128.33zm235.24-5.17h134.19c106.65 0 193.75-86.33 193.75-193.67 0-107.33-87.1-193.66-193.75-193.66h-134.19v387.33zm98.64-85.72V90.72h35.56c53.63 0 95.63 47.17 95.63 107.94 0 60.77-42 107.94-95.63 107.94h-35.56zm286.81 85.72h134.19c106.64 0 193.75-86.33 193.75-193.67 0-107.33-87.11-193.66-193.75-193.66h-134.19v387.33zm98.64-85.72V90.72h35.56c53.63 0 95.63 47.17 95.63 107.94 0 60.77-42 107.94-95.63 107.94h-35.56zM3412.62 4.99h-108.46l-76.08 121.36-76.1-121.36h-109.74l136.17 205.28v182.05h98.64V209.67L3412.62 4.99z",
    style: {
      fill: "#1d4b73"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoSlogan);
export default __webpack_public_path__ + "static/media/logo-no-slogan.fe0b582df1f0dd24e8507c121ef9adcb.svg";
export { ForwardRef as ReactComponent };